import { simpleSet } from '@r/reducers/utils';

const setCalculationModeWithInstallation = simpleSet as
  redux.reducers.calculationMode.settings.information.withInstallation;

export const withInstallation = setCalculationModeWithInstallation(
  'SET_CALCULATION_MODE_WITH_INSTALLATION',
  true
);
